    import { LuSearch } from "@/Components/Icons/Icons";
    export default {
      row1 : [
    {
        column: "column1",
        rows: {
        row1: [
            {
            name: "importConstituentName",
            label: "Name",
            component: "text-field",
            },
            {
            name: "importConstituentCode",
            label: "Code",
            component: "text-field",
            },
        ],
        row2: [
            {
            name: "importConstituentPercentage",
            label: "Percentage",
            component: "text-field",
            dataType : "int"
            },
            {
            name: "importConstituentYield",
            label: "Yield %",
            component: "text-field",
            dataType : "int"

            },
        ],
          row3: [
            {
              name: "importConstituentActive",
              label: "Active",
              component: "dropdown",
              width:"50%",
              options: [
                {
                  label: "Yes",
                  value: "Yes",
                },
                {
                  label: "No",
                  value: "No",
                },
              ],
            },
          ],
        },
    },
    ]
    };
